import AssessmentIcon from "@mui/icons-material/Assessment";
import FlagIcon from "@mui/icons-material/Flag";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AcxKeyInformationCard from "components/UI/AcxKeyInformationCard";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { AgentCoachingDetails } from "services/AgentCoachingService";

type Props = {
    coachingDetails: AgentCoachingDetails[];
};

const CoachingCards: FunctionComponent<Props> = observer((props) => {
    const totalCoached = "Coaching Completed";
    const totalCoachingAcknowledged = "Coaching Acknowledged";

    return props.coachingDetails.map((detail) => {
        return (
            <AcxKeyInformationCard
                key={`${detail.label}_${detail.value}`}
                id={`${detail.label}_${detail.value}`}
                title={detail.label}
                note={detail.note}
                icon={
                    detail.label === totalCoached ? (
                        <FlagIcon color="primary" />
                    ) : detail.label === totalCoachingAcknowledged ? (
                        <FactCheckIcon color="primary" />
                    ) : (
                        <AssessmentIcon color="primary" />
                    )
                }
                value={detail.value}
                valueLabel={detail.label === totalCoached ? "" : "%"}
            />
        );
    });
});

export default CoachingCards;
